export default "__VITE_ASSET__DuNcm2El__"